module.exports = "<div class=\"date-time js-date-region\"></div> <div class=\"date-time js-time-region\"></div> <div class=svg-icons-wrp> <div class=svg-icons-wrp__empty> <svg class=\"svg-icons svg-icons_date\"><use xlink:href=#icon-date /> </svg> </div> <div class=\"js-clear-button svg-icons-wrp__remove\"> <svg class=\"svg-icons svg-icons_remove\"><use xlink:href=#icon-remove /> </svg> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/templates/dateTimeEditor.hbs
// module id = 684
// module chunks = 0